import { useEffect, useState } from "react";
import { getFonts } from "../../services/axios";

export const Fonts = () => {
  const [loading, setLoading] = useState(false);
  const [fonts, setFonts] = useState<string[]>([]);
  const [updated, setUpdated] = useState<string | null>(null);

  useEffect(() => {
    const request = async () => {
      setLoading(true);
      const fontRequest = (await getFonts()) as {
        fonts: string;
        created_at: string;
      };
      if (fontRequest) {
        const fonts = fontRequest.fonts.split(",");

        setFonts(fonts);
        let time = new Date(Number(fontRequest.created_at)).toString();
        setUpdated(time);
        setLoading(false);
      }
    };
    request();
  }, []);

  return (
    <div className="bg-white flex flex-row justify-between items-center w-full">
      <div className="m-8 p-4 w-full">
        <div className="mt-16 space-y-16">
          {loading && <div>loading</div>}
          <p>last update - {updated}</p>
          <p>TO-DO add Filter; for now use Ctrl-F or Cmd-F to find a font</p>
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {fonts.map((font, fontIdx) => (
                  <tr
                    key={fontIdx}
                    className={fontIdx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {font}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
